import styled from '@emotion/styled'
import { ApiRebalancingFrequency, ApiRebalancingType, ApiSelfSelectPortfolio } from 'api/rtk-api'

import { availableTolerances, toleranceToPercentageString } from '../../../../utilities'
import { Numeric, Select, Space } from '../../atoms'
import { Attribute } from '../../molecules/attribute'

export type SelfSelectPortfolioDetailsProps = {
  calculatedMultiplier: number
  onChangeRebalancingFreq?: (freq: ApiRebalancingFrequency) => void
  onChangeRebalancingTolerance?: (tolerance: number) => void
  onChangeRebalancingType: (type: ApiRebalancingType) => void
  portfolio: ApiSelfSelectPortfolio
  taxClassification: 'Yield' | 'Capital'
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--White);
`

const StyledRebalanceOptions = styled.div`
  display: flex;
  gap: 4px;
  select {
    padding: 6px 0;
  }
`

export function SelfSelectPortfolioDetails({
  calculatedMultiplier,
  onChangeRebalancingFreq,
  onChangeRebalancingTolerance,
  onChangeRebalancingType,
  portfolio,
  taxClassification
}: SelfSelectPortfolioDetailsProps) {
  return (
    <>
      <Space mb={6}>
        <Wrapper>
          <Attribute name="Rebalancing type">
            <StyledRebalanceOptions>
              <Select
                value={portfolio?.rebalancingDefinition?.type}
                onChange={v => onChangeRebalancingType(v.target.value as ApiRebalancingType)}
              >
                <option value="None">None</option>
                <option value="Frequency">Frequency</option>
                <option value="CalendarFrequency">Calendar Frequency</option>
                <option value="Weight">Weight</option>
              </Select>
              {(portfolio?.rebalancingDefinition?.type === 'Frequency' ||
                portfolio?.rebalancingDefinition?.type === 'CalendarFrequency') && (
                <Select
                  value={portfolio?.rebalancingDefinition?.frequency}
                  onChange={v => onChangeRebalancingFreq(v.target.value as ApiRebalancingFrequency)}
                >
                  <option value="Monthly">Monthly</option>
                  <option value="Quarterly">Quarterly</option>
                  <option value="SemiAnnually">Semi annually</option>
                  <option value="Annually">Annually</option>
                </Select>
              )}
              {portfolio?.rebalancingDefinition?.type === 'Weight' && (
                <Select
                  value={portfolio?.rebalancingDefinition?.weightsTolerance}
                  onChange={v => onChangeRebalancingTolerance(Number(v.target.value))}
                >
                  {availableTolerances.map(c => (
                    <option key={c} value={c}>
                      {toleranceToPercentageString(c)}
                    </option>
                  ))}
                </Select>
              )}
            </StyledRebalanceOptions>
          </Attribute>
        </Wrapper>
      </Space>
      <Wrapper>
        <Attribute name="Continuous protection multiplier">
          <Numeric value={calculatedMultiplier} />
        </Attribute>
        <Attribute name="Term protection multiplier">
          <Numeric value={calculatedMultiplier} />
        </Attribute>
        <Attribute name="Tax classification">{taxClassification}</Attribute>
      </Wrapper>
    </>
  )
}
